import React from 'react';
import { connect } from 'react-redux';

import ColoredSectionContainer from 'components/no-auth/common/ColoredSectionContainer';
import { PromoPageContainer } from 'components/no-auth/common/promo-page-container/PromoPageContainer';
import { CardsSection } from 'components/no-auth/common/sections/CardsSection';
import HeadingSection from 'components/no-auth/common/sections/HeadingSection';
import { HeroSection } from 'components/no-auth/common/sections/HeroSection';
import { HighlightedTilesSection } from 'components/no-auth/common/sections/HighlightedTilesSection';
import { ListingTilesSection } from 'components/no-auth/common/sections/ListingTilesSection';
import LocationSection from 'components/no-auth/common/sections/LocationSection';
import LoneButtonSection from 'components/no-auth/common/sections/LoneButtonSection';
import { QuoteSectionV2 } from 'components/no-auth/common/sections/QuoteSectionV2';
import { TilesSection } from 'components/no-auth/common/sections/TilesSection';
import VideoSectionV2 from 'components/no-auth/common/sections/VideoSectionV2';
import NotAuthBasePage from 'components/no-auth/NotAuthBasePage';

const CulturePage = (props) => {
    return (
        <PromoPageContainer bgColor={'eggshell02'}>
            {props.heroTitle && <HeroSection title={props.heroTitle} text={props.heroText} bgImg={props.heroBgImg} img={props.heroImg} data={props.heroData} />}

            <ColoredSectionContainer bgColor={'purple5'}>
                <HeadingSection title={props.headline1Title} text={props.headline1Text} />
                {props.tilesHighlighted && <HighlightedTilesSection data={props.tilesHighlighted} />}
                {props.quote && <QuoteSectionV2 data={props.quote} loadingLazy />}
                {props.headline1Btn && <LoneButtonSection btn={props.headline1Btn} />}
            </ColoredSectionContainer>

            <ColoredSectionContainer bgColor={'eggshell03'} bottomPadding>
                {props.locations && props.locationTitle && props.locationText && (
                    <LocationSection data={props.locations} sectionTitle={props.locationTitle} sectionText={props.locationText} loadingLazy />
                )}
            </ColoredSectionContainer>

            <ColoredSectionContainer bgColor={'purple5'} bottomPadding>
                {props.whyJoinTitle && props.whyJoinText && <HeadingSection title={props.whyJoinTitle} text={props.whyJoinText} />}
                {props.tilesHighlighted2 && <HighlightedTilesSection data={props.tilesHighlighted2} />}
                {props.quote2 && <QuoteSectionV2 data={props.quote2} loadingLazy />}
            </ColoredSectionContainer>

            <ColoredSectionContainer bgColor={'white'}>
                {props.headline3Title && props.headline3Text && <HeadingSection title={props.headline3Title} text={props.headline3Text} />}
                {props.highlightedTilesWide && <CardsSection data={props.highlightedTilesWide} titleGradient="aubergine01" variant="halfWidth" />}
            </ColoredSectionContainer>

            <ColoredSectionContainer bgColor={'eggshell02'} bottomPadding>
                {props.imgTile && <TilesSection data={props.imgTile} loadingLazy />}
            </ColoredSectionContainer>
            <ColoredSectionContainer bgColor="purple5">
                {props.contentRowTiles && <CardsSection data={props.contentRowTiles} titleGradient="aubergine01" variant="contentRow" />}
            </ColoredSectionContainer>
            <ColoredSectionContainer>{props.quote3 && <QuoteSectionV2 data={props.quote3} loadingLazy />}</ColoredSectionContainer>

            {props.videoUrl && (
                <VideoSectionV2
                    sectionTitle={props.videoSectionTitle}
                    sectionText={props.videoSectionText}
                    btn={props.videoBtn}
                    videoUrl={props.videoUrl}
                    videoTitle={props.videoTitle}
                    videoPreviewImg={props.videoPreviewImg}
                    hasTopPadding
                    videoAtTop
                />
            )}

            <ColoredSectionContainer bgColor="purple5" bottomPadding>
                {props.headline4Title && props.headline4Text && <HeadingSection title={props.headline4Title} text={props.headline4Text} />}
                {props.iconTiles && <CardsSection data={props.iconTiles} bgColor="purple5" variant="iconTile" />}
                {props.opportunities && <TilesSection data={props.opportunities} />}
                {props.quote4 && <QuoteSectionV2 data={props.quote4} loadingLazy />}
                {props.headline4Btn && <LoneButtonSection btn={props.headline4Btn} variant={'tertiary'} iconName={'arrow-external'} />}
            </ColoredSectionContainer>

            <ColoredSectionContainer bgColor="eggshell02">
                {props.headline5Title && props.headline5Text && <HeadingSection title={props.headline5Title} text={props.headline5Text} />}
                {props.team && <ListingTilesSection data={props.team} centered loadingLazy />}
                {props.quote5 && <QuoteSectionV2 data={props.quote5} loadingLazy />}
                {props.headline6Title && props.headline6Text && (
                    <HeadingSection title={props.headline6Title} text={props.headline6Text} btn={props.headline6Btn} noBottomIndent />
                )}
            </ColoredSectionContainer>
        </PromoPageContainer>
    );
};
const mapStateToProps = (state) => {
    return {
        heroTitle: state.extra?.strapiApi?.hero_block?.title,
        heroText: state.extra?.strapiApi?.hero_block?.text,
        heroImg: state.extra?.strapiApi?.hero_block?.img,
        heroBgImg: state.extra?.strapiApi?.hero_block?.bgImg,
        heroData: state.extra?.strapiApi?.hero_block,

        headline1Title: state.extra?.strapiApi?.headline1?.title,
        headline1Text: state.extra?.strapiApi?.headline1?.text,
        headline1Btn: state.extra?.strapiApi?.headline1?.btn,

        tilesHighlighted: state.extra?.strapiApi?.tiles_highlighted,
        quote: state.extra?.strapiApi?.quote_section,

        locations: state.extra?.strapiApi?.location_section?.cards,
        locationTitle: state.extra?.strapiApi?.location_section?.title,
        locationText: state.extra?.strapiApi?.location_section?.text,

        whyJoinTitle: state.extra?.strapiApi?.headline2?.title,
        whyJoinText: state.extra?.strapiApi?.headline2?.text,

        tilesHighlighted2: state.extra?.strapiApi?.tiles_highlighted2,

        quote2: state.extra?.strapiApi?.quote_section2,

        headline3Title: state.extra?.strapiApi?.headline3?.title,
        headline3Text: state.extra?.strapiApi?.headline3?.text,

        highlightedTilesWide: state.extra?.strapiApi?.cards,

        imgTile: state.extra?.strapiApi?.tiles_section,

        contentRowTiles: state.extra?.strapiApi?.cards_2,

        quote3: state.extra?.strapiApi?.quote_section3,

        videoSectionTitle: state.extra?.strapiApi?.video_section?.title,
        videoSectionText: state.extra?.strapiApi?.video_section?.description,
        videoUrl: state.extra?.strapiApi?.video_section?.url,
        videoBtn: state.extra?.strapiApi?.video_section?.btn,
        videoPreviewImg: state.extra?.strapiApi?.video_section?.img,

        headline4Title: state.extra?.strapiApi?.headline4?.title,
        headline4Text: state.extra?.strapiApi?.headline4?.text,
        headline4Btn: state.extra?.strapiApi?.headline4?.btn,

        iconTiles: state.extra?.strapiApi?.cards_3,

        opportunities: state.extra?.strapiApi?.tiles_section2,

        quote4: state.extra?.strapiApi?.quote_section4,

        headline5Title: state.extra?.strapiApi?.headline5?.title,
        headline5Text: state.extra?.strapiApi?.headline5?.text,

        team: state.extra?.strapiApi?.person_cards,

        quote5: state.extra?.strapiApi?.quote_section5,

        headline6Title: state.extra?.strapiApi?.headline6?.title,
        headline6Text: state.extra?.strapiApi?.headline6?.text,
        headline6Btn: state.extra?.strapiApi?.headline6?.btn,
    };
};
export default connect(mapStateToProps)(NotAuthBasePage(CulturePage));
